var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',[_c('v-slider',{attrs:{"append-icon":"zoom_in","prepend-icon":"zoom_out"},on:{"click:append":_vm.zoomIn,"click:prepend":_vm.zoomOut},model:{value:(_vm.zoom),callback:function ($$v) {_vm.zoom=$$v},expression:"zoom"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }